import { lazy } from 'react';

const EfpaReport = lazy(() => import('./EfpaReport'));

export default EfpaReport;
